export default __webpack_public_path__ + "static/media/grafema_recta-intencao-book_13.3ccda894.jpg";